import React from "react";

export default function PrintIcon({ color = "#989898" }) {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1936_756)">
        <path
          d="M10.6667 0H2.66667V2.66667H10.6667M11.3333 6C11.1565 6 10.987 5.92976 10.8619 5.80474C10.7369 5.67971 10.6667 5.51014 10.6667 5.33333C10.6667 5.15652 10.7369 4.98695 10.8619 4.86193C10.987 4.7369 11.1565 4.66667 11.3333 4.66667C11.5101 4.66667 11.6797 4.7369 11.8047 4.86193C11.9298 4.98695 12 5.15652 12 5.33333C12 5.51014 11.9298 5.67971 11.8047 5.80474C11.6797 5.92976 11.5101 6 11.3333 6ZM9.33333 10.6667H4V7.33333H9.33333M11.3333 3.33333H2C1.46957 3.33333 0.960859 3.54405 0.585786 3.91912C0.210714 4.29419 0 4.8029 0 5.33333V9.33333H2.66667V12H10.6667V9.33333H13.3333V5.33333C13.3333 4.8029 13.1226 4.29419 12.7475 3.91912C12.3725 3.54405 11.8638 3.33333 11.3333 3.33333Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1936_756">
          <rect
            width="13.3333"
            height="12"
            fill={!!color ? color : "black"}
          />
        </clipPath>
      </defs>
    </svg>
  );
}
